import type { LeadStatus, UnitStatus } from '../../services/api';
import type { User } from '../../types';

export interface SidebarOptions {
  main: {
    what: {
      value: string;
      name_translated: string;
    }[];
    where: {
      type: {
        value?: string;
        name_translated?: string;
        msGroup?: boolean;
      }[];
      section?: {
        name?: string;
        msGroup?: boolean;
      }[];
    };
    reservationTypeOptions: UnitStatus[];
  };
  columns: {
    name_translated: string;
    value: string;
    selected?: boolean;
  }[];
  customFields: {
    name: string;
    slug: string;
    value: string;
    type: string;
    typeLabel: string;
    data: string[];
    dataMultiSelect: {
      name: string;
      disabled: boolean;
    }[];
    active?: boolean;
  }[];
  users: User[];
  usersWho: (User & { selected?: boolean })[];
  usersCreated: (User & { selected?: boolean })[];
  usersNoteCreated: (User & { selected?: boolean })[];
  usersUpdated: (User & { selected?: boolean })[];
  leadStatuses: (LeadStatus & { disabled: boolean })[];
  unitStatuses: UnitStatus[];
  itemsOfInterest: { id: string; name: string; selected: boolean }[];
  projects: { id: string; name: string; selected: boolean }[];
}

export const getSidebarOptions = ({
  $translate,
}: {
  $translate: angular.translate.ITranslateService;
}): SidebarOptions => ({
  main: {
    what: [
      {
        value: 'Interested',
        name_translated: $translate.instant(
          'leads.sidebar.select.what.interested',
        ),
      },
      {
        value: 'Booked',
        name_translated: $translate.instant('leads.sidebar.select.what.booked'),
      },
      {
        value: 'Extended reservation',
        name_translated: $translate.instant(
          'leads.sidebar.select.what.extended.reservation',
        ),
      },
      {
        value: 'Purchased',
        name_translated: $translate.instant(
          'leads.sidebar.select.what.purchased',
        ),
      },
      {
        value: 'Updated deal',
        name_translated: $translate.instant(
          'leads.sidebar.select.what.updated.deal',
        ),
      },
      {
        value: 'Canceled deal',
        name_translated: $translate.instant(
          'leads.sidebar.select.what.canceled.deal',
        ),
      },
    ],
    where: {
      type: [
        {
          name_translated: $translate.instant(
            'leads.sidebar.main.where.type.group.main',
          ),
          msGroup: true,
        },
        {
          value: 'apartment',
          name_translated: $translate.instant('unit.popup.apartment'),
        },
        {
          value: 'commercial',
          name_translated: $translate.instant('unit.popup.commercial.unit'),
        },
        {
          value: 'attic',
          name_translated: $translate.instant('unit.popup.attic'),
        },
        {
          value: 'hotel-type',
          name_translated: $translate.instant('unit.popup.hotel.type'),
        },
        { msGroup: false },
        {
          name_translated: $translate.instant(
            'leads.sidebar.main.where.type.group.individual',
          ),
          msGroup: true,
        },
        {
          value: 'cottage',
          name_translated: $translate.instant('unit.popup.cottage'),
        },
        {
          value: 'townhouse',
          name_translated: $translate.instant('unit.popup.townhouse'),
        },
        {
          value: 'duplex',
          name_translated: $translate.instant('unit.popup.duplex'),
        },
        {
          value: 'plot',
          name_translated: $translate.instant('unit.popup.land.plot'),
        },
        {
          value: 'villa',
          name_translated: $translate.instant('unit.popup.villa'),
        },
        { msGroup: false },
        {
          name_translated: $translate.instant(
            'leads.sidebar.main.where.type.group.other',
          ),
          msGroup: true,
        },
        {
          value: 'store-room',
          name_translated: $translate.instant('unit.popup.store.room'),
        },
        {
          value: 'parking-lot',
          name_translated: $translate.instant('unit.popup.parking.lot'),
        },
        {
          value: 'pavement-parking',
          name_translated: $translate.instant('unit.popup.pavement.parking'),
        },
        { msGroup: false },
      ],
    },
    reservationTypeOptions: [],
  },
  columns: [
    {
      name_translated: $translate.instant('leads.table.ibp'),
      value: 'unit_info',
      selected: true,
    },
    {
      name_translated: $translate.instant('leads.buttons.sort.lead.status'),
      value: 'lead_status',
      selected: true,
    },
    {
      name_translated: $translate.instant('leads.sidebar.select.created'),
      value: 'created_at',
    },
    {
      name_translated: $translate.instant('leads.sidebar.user.created'),
      value: 'created_by',
    },
    {
      name_translated: $translate.instant('leads.table.last.action'),
      value: 'last_action',
    },
  ],
  customFields: [],
  users: [],
  usersWho: [],
  usersCreated: [],
  usersNoteCreated: [],
  usersUpdated: [],
  leadStatuses: [],
  unitStatuses: [],
  itemsOfInterest: [],
  projects: [],
});
